import axios from 'axios'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

const request =  axios.create({
    baseURL: process.env.BASE_API,
    timeout: 10000
})

export default request



// WEBPACK FOOTER //
// ./src/api/index.js